<template>
  <modal
    class="createAssetGroup"
    name="createTerminal"
    transition="pop-out"
    :width="700"
    :height="500"
    @opened="opened"
    @closed="closed"
  >
    <div class="text-center assets_modal_div">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">
        {{ $t("text.createTerminalModal.createTerminal") }}
      </p>
      <form>
        <!-- select branch -->
        <div class="modal_form_field">
          <label class="assets_label">{{
            $t("text.reAssignPosModal.selectBranch")
          }}</label>
          <select class="form-control" v-model="branchId">
            <option disabled value="Select bank">
              {{ $t("text.reAssignPosModal.selectBranch") }}
            </option>
            <option :value="br.id" v-for="(br, i) in branches" :key="i">
              {{ br.name }}
            </option>
          </select>
        </div>
        <!--  -->

        <div class="modal_form_field" style="margin-top: -20px">
          <label class="assets_label">{{
            $t("text.createTerminalModal.terminalId")
          }}</label>
          <input class="modal_input" v-model="terminalId" />
        </div>
        <div class="modal_form_field" style="margin-top: -20px">
          <label class="assets_label">{{
            $t("text.createTerminalModal.serialNo")
          }}</label>
          <input class="modal_input" v-model="seriaNo" />
        </div>

        <!-- Select Bank -->

        <div class="modal_form_field" v-if="branchId" style="margin-top: -20px">
          <label class="assets_label">{{
            $t("text.createTerminalModal.bank")
          }}</label>
          <select class="form-control" v-model="posBank">
            <option disabled value="Select bank">
              {{ $t("text.createTerminalModal.selectBank") }}
            </option>
            <option
              v-for="(bank, index) in banks"
              :value="bank.bankName"
              :key="index"
            >
              {{ bank.bankName }}
            </option>
          </select>
        </div>

        <!--  -->

        <button
          @click="createTerminal($event)"
          class="assets_button"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
          style="margin-top: -20px"
        >
          {{ $t("text.createTerminalModal.createTerminal") }}
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="20px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "createTerminal",
  props: ["companyId", "branches"],
  data() {
    return {
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      modalWidth: MODAL_WIDTH,
      name: "",
      description: "",
      groupType: "selectGroupType",
      isButtonDisabled: false,
      showLoader: false,
      data: {},
      posBank: "Select bank",
      seriaNo: null,
      banks: [],
      terminalId: null,
      branchId: null,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  mounted() {},

  watch: {
    branchId: function (branch) {
      if (branch) {
        this.getBanks();
      }
    },
  },

  methods: {
    closed() {
      this.posBank == "Select bank";
      this.serialNo = null;
      this.terminalId = null;
    },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Banks?branchId=${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            if (a.bankName < b.bankName) {
              return -1;
            } else {
              return 1;
            }
          });
          this.banks = response.data;
        })
        .catch((error) => {});
    },
    closeModal() {
      this.$modal.hide("createTerminal");
    },
    opened() {
      this.getBanks();
      this.data = this.modalData;
    },
    createTerminal(e) {
      e.preventDefault();
      if (!this.branchId) {
        this.$toast.open({
          message: "Please a branch",
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.terminalId) {
        this.$toast.open({
          message: "Please input a termianal ID",
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (!this.seriaNo) {
        this.$toast.open({
          message: "Please input a serial number",
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.posBank == "Select bank") {
        this.$toast.open({
          message: "Please select a bank",
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        terminalId: this.terminalId,
        serialNo: this.seriaNo,
        branchId: this.branchId,
        bank: this.posBank,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/pos/CreateOtherTerminal`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.$toast.open({
            message: "Successfully created terminal",
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.posBank == "Select bank";
          this.serialNo = null;
          this.terminalId = null;
          this.$eventHub.$emit("refreshTerminalsList");
          this.closeModal();
        })
        .catch((e) => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
